// @flow
import React from 'react'
import styles from './SearchForm.module.css'



const SearchForm = ({
  onSubmit,
  placeholder,
  searchFormClassName,
  setValue,
  value,
}) => (
  <form
    data-testid="SearchFormForm"
    onSubmit={onSubmit}
    autoComplete="off"
    className={`${styles.form}${
      searchFormClassName ? ` ${searchFormClassName}` : ''
    }`}
  >
    <input
      data-testid="SearchFormInput"
      type="text"
      placeholder={placeholder}
      onChange={setValue}
      value={value}
      name="search"
      className={styles.input}
    />
  </form>
)

export default SearchForm
